// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '../../../../../../../node_module_clones/react-router';

// Utils
import { getElementId, getTitle } from '../../../../../../../common/elements/utils/elementPropertyUtils';
import { getNotificationElementId } from '../../../../../../../common/notifications/notificationModelUtils';
import { chooseSingular } from '../../../../../../../common/utils/stringUtil';

// Components
import BaseNotificationEntry from './BaseNotificationEntry';
import UserNames from './UserNames';
import NotificationUserFigure from './NotificationFigureUser';
import Icon from '../../../../../../components/icons/Icon';

// Constants
import { USER_AVATAR_SIZES } from '../../../../../../../common/users/userConstants';

// Styles
import './NotificationEntryLiveEditing.scss';

export const getBoardUrl = ({ element, notification }) => {
    const elementId = getElementId(element) || getNotificationElementId(notification);
    return `/${elementId}`;
};

const NotificationEntryLiveEditing = (props) => {
    const { users, board } = props;

    const boardTitle = getTitle(board);
    const url = getBoardUrl({ element: board });

    return (
        <Link className="NotificationEntryLiveEditing" tabIndex={-1} to={url}>
            <BaseNotificationEntry
                time={<span>Now</span>}
                figure={
                    <NotificationUserFigure
                        actors={users}
                        size={USER_AVATAR_SIZES.REGULAR}
                        icon={<Icon name="notification-live" />}
                    />
                }
            >
                <div className="notification-statement">
                    <UserNames users={users} /> {chooseSingular(users.length, 'is ', 'are')} viewing{' '}
                    <span className="board-title"> {boardTitle}</span>
                </div>
            </BaseNotificationEntry>
        </Link>
    );
};

NotificationEntryLiveEditing.propTypes = {
    board: PropTypes.object,
    users: PropTypes.array,
    notification: PropTypes.object,
    isMobile: PropTypes.bool,
};

export default NotificationEntryLiveEditing;
